import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';
import { CoreComponent } from '../core/core.component.js';
import { IImage } from '../ui-models.js';

export interface ISelectionCardItem {
	title: string;
	image?: IImage;
	click: () => void;
}

export type SelectionCardDesign = 'default' | 'alt';

@Component({
    selector: 'ui-selection-cards',
    templateUrl: './selection-cards.component.html',
    styleUrls: ['./selection-cards.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectionCardsComponent extends CoreComponent {
	public readonly items = input.required<ISelectionCardItem[]>();
	public readonly design = input<SelectionCardDesign>('default');

	public readonly itemsPerWidth: Signal<string> = computed(() => {
		if (this.isMobileView()) {
			return super.calculateFlexWidth(1, 24);
		}
		return super.calculateFlexWidth(3, 24);
	});
}
